import client from "./client";

const getIndustries = () =>
  client.get("/subsidiary/dashboard/business/categories");

export default { getIndustries };
